import { Component } from "@angular/core";

@Component({
  selector: "accordion-heading",
  template: `<ng-content></ng-content>`
})
export class AccordionHeading {

}